export enum WsMessageType {
  authLogin = 'auth.login',
  authSuccess = 'auth.success',
  aiPrompt = 'ai.prompt',
  aiResponse = 'ai.response',
  resourceEvent = 'resource.event',
  error = 'error',
}

export enum WsResourceType {
  user = 'user',
  order = 'order',
  transport = 'transport',
  transportPorter = 'transport_porter',
  yard = 'yard',
  client = 'client',
  clientEmail = 'client_email',
  route = 'route',
  reportRecipient = 'report_recipient',
  vehicle = 'vehicle',
  van = 'van',
  orderItem = 'order_item',
  orderTransport = 'order_transport',
  emergency = 'emergency',
  case = 'case',
  caseSlot = 'case_slot',
  keyAction = 'key_action',
  yardAuditKey = 'yard_audit_key',
}

export enum WsEventType {
  created = 'created',
  updated = 'updated',
  deleted = 'deleted',
}

export enum WsErrorInternalCodeType {
  invalidJson = 'invalid_json',
  invalidMessageFormat = 'invalid_message_format',
  unsupportedMessageType = 'unsupported_message_type',
  authRequired = 'auth_required',
  invalidTokenOrRole = 'invalid_token_or_role',
  emptyPrompt = 'empty_prompt',
  lockNotAcquired = 'lock_not_acquired',
  aiConversationInitFailed = 'ai_conversation_init_failed',
  aiCommunicationFailed = 'ai_communication_failed',
  aiPermissionDenied = 'ai_permission_denied',
}

export interface WsAuthLoginPayload {
  token: string;
}

export interface WsAuthSuccessPayload {
  username: string;
}

export interface WsAiPromptPayload {
  prompt: string;
}

export interface WsAiResponsePayload {
  response: string;
}

export interface WsResourceEventPayload {
  eventType: WsEventType;
  resourceType: WsResourceType;
  resourceId: number;
}

export interface WsErrorPayload {
  message: string;
  internalCode: WsErrorInternalCodeType;
}

export interface WsMessage<T> {
  type: WsMessageType;
  payload: T
}
